import { useApolloClient, useQuery, useSubscription } from '@apollo/client'
import { INQUIRY_SENDER } from '@medical/constant'
import { STAFF_ASSIGN_REPLY_PERMISSION } from '@medical/constant/permissions'
import { STAFF_ME } from '@medical/layout/StaffLayout/StaffLayout.graphql'
import { useCustom } from '@medical/provider/context'
import queryString from 'query-string'
import React, { useEffect, useState } from 'react'

import {
  ACTIVE_STAFFS_QUERY,
  CONVERSATIONS_LIST,
  STAFF_MSG_SUBSCRIPTION,
} from './Inquiries.graphql'
import InquiriesScene from './InquiriesScene'

const Inquiries = ({ location: { search } }) => {
  const { doctorId, doctorName, conversationId } = queryString.parse(search)
  const [{ i18n, popup }, { setNewMsg }] = useCustom()
  const client = useApolloClient()

  // Get current staff info from cache
  const { staffMe } = client.readQuery({ query: STAFF_ME })
  const hasAssignPermission = staffMe.staffGroup.permissions.some(
    p =>
      p.api.name === STAFF_ASSIGN_REPLY_PERMISSION &&
      p.deletedAt === null &&
      p.action === 'ALL'
  )
  const { data: staffsData } = useQuery(ACTIVE_STAFFS_QUERY, {
    fetchPolicy: 'network-only',
  })
  const activeStaffs = staffsData ? staffsData.activeStaffs : []
  const [statusSearch, setStatusSearch] = useState(['0', '1', '2', '3'])
  const [dataConversation, setDataConversation] = useState([])
  const [first] = useState(10)
  const [skip, setSkip] = useState(0)
  const [isEndConversation, setIsEndConversation] = useState(0)
  const statusFilterMap = {
    '0': { status: 'NEW' },
    '1': { isReadByStaff: false },
    '2': { status: 'IN_RESPONSE' },
    '3': { status: 'COMPLETED' },
  }

  const buildStatusFilter = () => {
    if (!statusSearch || statusSearch.length === 0) return {}
    const conditions = statusSearch.map(key => statusFilterMap[key]).filter(Boolean)
    if (conditions.length === 0) return {}
    return { OR: conditions }
  }

  const variables = {
    first,
    skip,
    orderBy: 'receivedLastMessageAt_DESC',
    where: {
      ...buildStatusFilter(),
      Doctor: {
        id_not: null,
      },
    },
  }
  const getConversations = async (offset = 0, limit = 10) => {
    try {
      const {
        data: { conversations },
      } = await client.query({
        query: CONVERSATIONS_LIST,
        variables: {
          ...variables,
          first: limit,
          skip: offset,
        },
        fetchPolicy: 'network-only',
      })
      const filtered = hasAssignPermission
        ? conversations
        : conversations.filter(c => c.assignedStaff === staffMe.id)
      if (conversations.length === 0) {
        setIsEndConversation(1)
      }
      return filtered
    } catch (error) {
      return []
    }
  }

  const getMoreConversation = async () => {
    try {
      if (isEndConversation === 0) {
        const edges = await getConversations(skip + 10)
        setDataConversation([...dataConversation, ...edges])
        setSkip(skip + 10)
      }
    } catch (error) {
      popup.error(error)
    }
  }
  useEffect(() => {
    async function fetchMyAPI() {
      const edges = await getConversations()
      setDataConversation([...edges])
    }
    fetchMyAPI()
  }, [statusSearch])

  useSubscription(STAFF_MSG_SUBSCRIPTION, {
    variables,
    onSubscriptionData: () => {
      async function getMsg() {
        const edges = await getConversations()
        setDataConversation(edges)
        setSkip(0)
        setIsEndConversation(0)
      }
      getMsg()
    },
  })

  return (
    <InquiriesScene
      i18n={i18n}
      setNewMsg={setNewMsg}
      popup={popup}
      // conversations={
      //   statusSearch
      //     ? dataConversation.filter(item => item.status === statusSearch)
      //     : dataConversation
      // }
      conversations={dataConversation}
      setDataConversation={setDataConversation}
      activeStaffs={activeStaffs}
      inquirySender={INQUIRY_SENDER.STAFF}
      doctorId={doctorId || ''}
      doctorNameFromParams={doctorName || ''}
      conversationIdFromParams={conversationId || ''}
      statusSearch={statusSearch}
      setStatusSearch={e => {
        setStatusSearch(e)
        setIsEndConversation(0)
        setSkip(0)
      }}
      getMoreConversation={getMoreConversation}
    />
  )
}

export default Inquiries
